import { ICustomer } from "src/modules/customer/model/customer.model";

export class GetMicrosoftOverview {
  static readonly type = '[Overview] GetMicrosoftOverview';
  constructor(public customer: ICustomer){}
}
